import jsPDF from 'jspdf';
import { Colonia } from '../../types/colonia';
import { gerarCarteirinha } from './carteirinhaImage';

/* A4 retrato, com o máximo de pares frente+verso de 9cm de largura (proporção do
   modelo, 3:2) que cabem sem invadir a margem de corte. */
const PAGE_W = 210;
const PAGE_H = 297;
const CARD_W = 90;
const CARD_H = 60; // 90 * (1024 / 1536)
const GAP_X = 6;
const GAP_Y = 8;
const ROWS_PER_PAGE = 4;
const PAIR_W = CARD_W * 2 + GAP_X;
const CONTENT_H = ROWS_PER_PAGE * CARD_H + (ROWS_PER_PAGE - 1) * GAP_Y;
const MARGIN_X = (PAGE_W - PAIR_W) / 2;
const MARGIN_Y = (PAGE_H - CONTENT_H) / 2;
/** Cada carteirinha é gerada em alta resolução (mais pesado que a miniatura da lista);
    lotes pequenos mantêm a aba respondendo entre um grupo e outro. */
const LOTE = 3;

const canvasParaJpeg = (canvas: HTMLCanvasElement | null) => {
  if (!canvas) return null;
  try {
    return canvas.toDataURL('image/jpeg', 0.86);
  } catch {
    return null;
  }
};

const desenharGuiaCorte = (doc: jsPDF, x: number, y: number) => {
  doc.setDrawColor(190);
  doc.setLineWidth(0.1);
  doc.setLineDashPattern([1, 1], 0);
  doc.rect(x, y, CARD_W, CARD_H, 'S');
};

export const gerarPdfCarteirinhas = async (
  inscricoes: Colonia[],
  onProgress?: (feito: number, total: number) => void
): Promise<jsPDF> => {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
  let linhaNaPagina = 0;

  for (let inicio = 0; inicio < inscricoes.length; inicio += LOTE) {
    const lote = inscricoes.slice(inicio, inicio + LOTE);
    const gerados = await Promise.all(
      lote.map(async (inscricao) => {
        const [canvasFrente, canvasVerso] = await Promise.all([
          gerarCarteirinha(inscricao, 'frente'),
          gerarCarteirinha(inscricao, 'verso')
        ]);
        return { frente: canvasParaJpeg(canvasFrente), verso: canvasParaJpeg(canvasVerso) };
      })
    );

    for (let indice = 0; indice < gerados.length; indice += 1) {
      const par = gerados[indice];
      if (linhaNaPagina === ROWS_PER_PAGE) {
        doc.addPage();
        linhaNaPagina = 0;
      }
      const y = MARGIN_Y + linhaNaPagina * (CARD_H + GAP_Y);
      const xFrente = MARGIN_X;
      const xVerso = MARGIN_X + CARD_W + GAP_X;

      if (par.frente) doc.addImage(par.frente, 'JPEG', xFrente, y, CARD_W, CARD_H);
      desenharGuiaCorte(doc, xFrente, y);
      if (par.verso) doc.addImage(par.verso, 'JPEG', xVerso, y, CARD_W, CARD_H);
      desenharGuiaCorte(doc, xVerso, y);

      linhaNaPagina += 1;
      onProgress?.(inicio + indice + 1, inscricoes.length);
    }
  }

  return doc;
};

export const baixarPdfCarteirinhas = async (
  inscricoes: Colonia[],
  onProgress?: (feito: number, total: number) => void
) => {
  const doc = await gerarPdfCarteirinhas(inscricoes, onProgress);
  const data = new Date().toISOString().slice(0, 10);
  doc.save(`carteirinhas-colonia-ferias-${data}.pdf`);
};
